import { BaseEntity } from "@common/ADAPT.Common.Model/base-entity";
import { BreezeModelBuilder } from "@common/ADAPT.Common.Model/breeze-model-builder";
import { Organisation } from "./organisation";
import { ProgressCategory } from "./progress-category";
import { ProgressProductCode } from "./progress-product-code";

export class ProgressProduct extends BaseEntity<ProgressProduct> {
    public progressProductId!: number;
    public organisationId?: number;
    public name!: string;
    public code?: string | ProgressProductCode;
    public ordinal!: number;

    public organisation?: Organisation;
    public progressCategories!: ProgressCategory[];
}

export const ProgressProductBreezeModel = new BreezeModelBuilder("ProgressProduct", ProgressProduct)
    .hasSource()
    .withIdField()
    .isOrganisationEntity()
    .orderBy("ordinal")
    .alwaysFetchingNestedNavigationProperty("progressCategories.progressItems")
    .build();
